<template>
  <v-dialog v-model="dialog" persistent max-width="390">
    <v-card class="pa-4">
      <div class="d-flex justify-space-between mb-4">
        <v-card-title class="text-h5"> Delete Event </v-card-title>
        <v-icon class="mx-5" @click="$emit('update:dialog', false)">mdi-close</v-icon>
      </div>
      <v-card-text class="index_span_2_style mb-4">
        Are you sure you want to delete {{ deleteId }} at {{ deleteLocation }}?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#646464" outlined depressed text @click="$emit('update:dialog', false)">
          <span class="text_style"> Don't delete </span>
        </v-btn>
        <v-btn color="primary" class="px-5" depressed :disabled="btnloader" @click="$emit('deleteConfirmed')">
          <span class="text_style" v-if="!btnloader"> Delete Event </span>
          <v-progress-circular indeterminate size="20" v-else class="px-5" color="white" />
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteEvent",
  props: {
    dialog: Boolean,
    deleteId: Number,
    deleteLocation: String,
    btnloader: Boolean,
  },
};
</script>

<style scoped>
.index_span_2_style {
  font-family: "DM Sans";
  font-size: 16px;
  color: #646464;
}

.text_style {
  font-family: "DM Sans";
  font-size: 14px;
  text-transform: capitalize;
}
</style>